import { render } from "./ContactsView.vue?vue&type=template&id=589c7ddc&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"

import "./ContactsView.vue?vue&type=style&index=0&id=589c7ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589c7ddc"]])

export default __exports__